var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M0 24.5C0 38.031 10.969 49 24.5 49C38.031 49 49 38.031 49 24.5C49 10.969 38.031 0 24.5 0C10.969 0 0 10.969 0 24.5Z",
    fill: "#414141"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_300_59",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 49,
    height: 49
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M0 24.5C0 38.031 10.969 49 24.5 49C38.031 49 49 38.031 49 24.5C49 10.969 38.031 0 24.5 0C10.969 0 0 10.969 0 24.5Z",
    fill: "#FA756D"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_300_59)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 49C7 58.9411 15.0589 67 25 67C34.9411 67 43 58.9411 43 49C43 39.0589 34.9411 36 25 36C15.0589 36 7 39.0589 7 49Z",
    fill: "#414141"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 22.5C13 28.8513 18.1487 34 24.5 34C30.8513 34 36 28.8513 36 22.5C36 16.1487 30.8513 11 24.5 11C18.1487 11 13 16.1487 13 22.5Z",
    fill: "#414141"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultAvatar);
export default __webpack_public_path__ + "static/media/defaultAvatar.2e5cc254aa450e397f85d19cba4c1194.svg";
export { ForwardRef as ReactComponent };